var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loader'),_c('div',{staticClass:"wrapper"},[_c('SidebarStyle3'),_c('HeaderStyle3'),_c('div',{staticClass:"content-page"},[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)],1),_c('FooterStyle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }